function getInitialTicketTypeQuantity(ticketType, ticketGroup) {
  if (!ticketGroup.isOnSale || !ticketType.isOnSale) {
    return 0;
  }

  if (ticketGroup.preselect?.enabled && ticketGroup.preselect.ticketType === ticketType._id) {
    if (ticketGroup.ticketSelectionType === 'quantity') {
      return ticketGroup.preselect?.quantity || 1;
    } else {
      return 1;
    }
  }

  return 0;
}

export function getTicketGroupsFormState(ticketGroups, query = {}, draftCheckout = null) {
  if (!ticketGroups || !ticketGroups.length) return [];

  // set default values
  // return the preselected option if preselect is enabled
  const ticketGroupsFormState = ticketGroups.reduce((obj, ticketGroup) => {
    obj[ticketGroup._id] = ticketGroup.ticketTypes.map(ticketType => ({
      ticketTypeId: ticketType._id,
      quantity: getInitialTicketTypeQuantity(ticketType, ticketGroup),
    }));

    return obj;
  }, {});

  // Pre-populate from draft checkout tickets if available
  if (draftCheckout?.tickets && draftCheckout.tickets.length > 0) {
    draftCheckout.tickets.forEach(draftTicket => {
      // Handle both object and ID formats for ticketType and ticketGroup
      const ticketTypeId = typeof draftTicket.ticketType === 'object' 
        ? draftTicket.ticketType._id 
        : draftTicket.ticketType;
      
      const ticketGroupId = typeof draftTicket.ticketGroup === 'object' 
        ? draftTicket.ticketGroup._id 
        : draftTicket.ticketGroup;

      // Find the ticket group and ticket type for this draft ticket
      const ticketGroup = ticketGroups.find(group => 
        group._id === ticketGroupId || 
        group.ticketTypes.some(type => type._id === ticketTypeId)
      );

      if (ticketGroup && ticketTypeId) {
        const ticketType = ticketGroup.ticketTypes.find(type => type._id === ticketTypeId);
        
        if (ticketType && draftTicket.quantity > 0) {
          // Ensure the ticket group form state is properly initialized
          if (!ticketGroupsFormState[ticketGroup._id]) {
            ticketGroupsFormState[ticketGroup._id] = ticketGroup.ticketTypes.map(type => ({
              ticketTypeId: type._id,
              quantity: 0,
            }));
          }
          
          // Find existing ticket type entry and update quantity
          let ticketTypeEntry = ticketGroupsFormState[ticketGroup._id].find(
            entry => entry.ticketTypeId === ticketType._id
          );
          
          if (ticketTypeEntry) {
            // Update existing entry
            ticketTypeEntry.quantity = draftTicket.quantity;
          } else {
            // Add new entry (shouldn't happen with proper initialization above)
            ticketGroupsFormState[ticketGroup._id].push({
              ticketTypeId: ticketType._id,
              quantity: draftTicket.quantity,
            });
          }
        }
      }
    });
  }

  // match params to form field references (query params override draft data)
  Object.entries(query).forEach(([key, value]) => {
    const ticketGroup = ticketGroups.find(ticketGroup => ticketGroup.reference === key);

    if (ticketGroup && ticketGroup.isOnsale) {
      const ticketType = ticketGroup.ticketTypes.find(ticketType => ticketType.reference === value);

      if (ticketType && ticketType.isOnSale) {
        ticketGroupsFormState[ticketGroup._id] = [
          {
            ticketTypeId: ticketType._id,
            quantity: 1,
          },
        ];
      }
    }
  });

  return ticketGroupsFormState;
}
